module.exports = __webpack_public_path__ + "img/clear-24px.d5910dd0.svg";